import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


import { CartService } from 'src/app/services/dhukan/cart.service';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';

@Component({
  selector: 'app-orderstatus',
  templateUrl: './orderstatus.component.html',
  styleUrls: ['./orderstatus.component.css']
})
export class OrderstatusComponent implements OnInit {

  @Input() mobileno:any=""

  @Input() cartid:any=0

  cartBO: any = {};
  cartColl: any = [];
  cartView: any = {};
  orderColl: any = [];

  @Output() emitData = new EventEmitter();
  
  constructor(private appService: DhukanDataService, public router: Router, 
    private productFindService: NgbModal, private cartservice: CartService, private activeModal: NgbActiveModal) {
      this.fnServiceChanges()
     }

     fnServiceChanges() {
      this.cartView = this.cartservice.cartView;
      this.cartservice.servicecartChange.subscribe((value) => {
        this.cartView = value
        if (this.cartView.cartmain) {
          this.cartBO = this.cartView.cartmain
        }
        if (this.cartView.orderColl) {
          this.orderColl = this.cartView.orderColl
        }
      
      });
  
    }

  ngOnInit(): void {

    this.cartView = this.cartservice.cartView;
    if (this.cartView.cartmain) {
      this.cartBO = this.cartView.cartmain
    }
    if (this.cartView.orderColl) {
      this.orderColl = this.cartView.orderColl
    }
    this.cartView = this.cartservice.cartView;
  }


  fnOrderBtnClikc(){
    this.emitData.emit("VIEWORDER")
    this.activeModal.close(true);
  }
  
  public decline() {


    this.activeModal.close(false);
  }

}
